import React, { Component } from 'react';
import { getAppCfg } from '../../utils/common';
import { Grid } from '@material-ui/core';

function PrivacyPolicyPage(props) {

    const resul = getAppCfg();
    const about_details = resul&&resul.about_details?resul.about_details: null;

    var    content = about_details && about_details.privacy_policy && about_details.privacy_policy.content ? about_details.privacy_policy.content : ""
    return (
            <Grid item>    
                <div dangerouslySetInnerHTML={{__html: content}}/>
            </Grid>

    );
}

export default PrivacyPolicyPage;